<template>
  <div class="pb-5">
    <v-simple-table class="blended-table table-layout table-fixed" id="style-2" fixed-header :height="tableHeight + 'px'">
      <template v-slot:default>
        <thead>
        <tr>
          <th style="min-width: 50px; max-width:50px">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <img @click="handleSortUpdatedAt" style="cursor: pointer" v-on="on" v-bind="attrs" src="../../assets/sort-icon.svg" alt="">
              </template>
              <span>{{filterForm.sortUpdatedAt === 'desc' ? 'Từ mới đến cũ' : 'Từ cũ đến mới'}}</span>
            </v-tooltip>
          </th>
          <th style="min-width: 50px; max-width:50px; left:0px" class="sroll-left">
            <input
              type="checkbox"
              class="course-extension-checkbox"
              v-model="filterForm.checkboxAll"
              @change="onChangeCheckboxAll"
            >
          </th>
          <th style="min-width: 245px; max-width:245px; left:50px" class="sroll-left">Học viên</th>
          <th style="min-width: 140px; max-width:140px;left:263px" class="sroll-left">SĐT</th>
          <th style="min-width: 164px; max-width:164px">Trạng thái</th>
          <th style="min-width: 230px; max-width:230px;left:379px" class="sroll-left">Quản lý lớp</th>
          <th style="width: 100px;">Sale gia hạn</th>
          <th style="width: 100px;">Mã lớp</th>
          <th style="width: 100px;">Sản phẩm</th>
          <th style="width: 100px;">Buổi đã học</th>
          <th style="width: 100px;">Hết hạn</th>
        </tr>
        </thead>
        <tbody
          v-if="dataPeriodicallyCareTable && dataPeriodicallyCareTable.data && dataPeriodicallyCareTable.data.length"
        >
        <tr v-for="(item, index) in dataPeriodicallyCareTable.data"
            :key="`${item.id}_${index}`"
            class="bg-hover"
        >
          <td style="text-align: center; min-width: 50px;">{{index + 1 + (filterForm.page - 1)* filterForm.limit}}</td>
          <td class="sroll-left"
            :style="`background-color: ${mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].color : ''}`"
          style="text-align: center; left:0px; min-width: 50px; max-width:50px">
            <div class="d-flex align-center justify-center">
              <input type="checkbox" class="course-extension-checkbox" v-model="item.checkbox"
                     @change="changeItemSelect(item.checkbox)">
            </div>
          </td>
          <td class="sroll-left" style="left:50px; min-width: 245px; max-width: 245px;" >
            <div class="d-flex justify-space-between" style="font-weight: bold; font-size: 14px">
              <span @click="showQuickView(item)" style="cursor: pointer; white-space: normal">
              {{ item.full_name }}
              </span>
              <div class="d-flex align-center ml-2">
                <v-menu offset-y v-if="item.phoneRelated && item.phoneRelated.length">
                  <template v-slot:activator="{ on: menu, attrs }">
                      <div
                        class="d-flex flex-column align-center"
                        v-bind="attrs"
                        v-on="menu"
                      >
                        <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                      </div>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="clickExecuteCall(item, item.mobile)"
                      class="main-mobile"
                    >
                      <v-list-item-title>{{item.mobile}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(phone, index) in item.phoneRelated"
                      :key="index"
                      @click="clickExecuteCallphoneRelated(item, phone)"
                      class="sub-mobile"
                    >
                      <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <div
                  v-else
                  style="cursor: pointer"
                  @click.stop="clickExecuteCall(item, item.mobile)"
                >
                  <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                </div>
                <v-tooltip top>
                  <template v-slot:activator="{ on,attrs }">
                    <div
                      v-if="$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && (checkAuthorization('create-task-tutor_create') || checkAuthorization('create-task-tutor-secondary_create'))"
                      v-on="on"
                      v-bind="attrs"
                    >
                      <img src="../../assets/createtask.svg" style="cursor: pointer" class="ml-4" alt="" srcset=""  @click="createTask(item)">
                    </div>
                  </template>
                  <div>Tạo công việc</div>
                </v-tooltip>
              </div>
            </div>
          </td>
          <td class="sroll-left" style="left:263px;min-width: 140px; max-width:140px">
            <div @click.stop="">
              {{ item.mobile }}
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    size="small"
                    rounder
                    icon
                    v-on="on"
                    @click="copyMobile(item)"
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copy</span>
              </v-tooltip>
            </div>
          </td>
          <td style="min-width: 164px; max-width:164px">
            <div v-if="item.call_status_id"
                 :style="`color: ${mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].color : ''}`"
            >
              {{
                mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].callStatus : ''
              }}
            </div>
            <img v-else src="../../assets/empty-data.svg" alt="">
          </td>
          <td class="sroll-left" style="left:379px;min-width: 230px; max-width:230px;">
            <div v-if="item.homeroom_teacher_name">
              {{ item.homeroom_teacher_name }}
            </div>
            <img v-else src="../../assets/empty-data.svg" alt="">
          </td>
          <td>
            <div v-if="item.extend_sale_name">
              {{ item.extend_sale_name}}
            </div>
            <img v-else src="../../assets/empty-data.svg" alt="">
          </td>
          <td>
            <div v-if="item.class_code">
              {{ item.class_code}}
            </div>
            <img v-else src="../../assets/empty-data.svg" alt="">
          </td>
          <td>
            <div v-if="item.products && item.products.length > 0">
              <div v-for="(productItem, index) in item.products" :key="index">
                <p style="margin-bottom: 0px">{{productItem.product}}</p>
              </div>
            </div>
            <img v-else src="../../assets/empty-data.svg"/>
          </td>
          <td>{{item.number_lesson_passed}}/{{item.number_lessons}}</td>
          <td>
            <div v-if="item.end_date">
              {{ formatDateLocal(item.end_date)}}
            </div>
            <img v-else src="../../assets/empty-data.svg" alt="">
          </td>
        </tr>
        </tbody>
        <tbody v-else-if="dataPeriodicallyCareTable && dataPeriodicallyCareTable.otherData && dataPeriodicallyCareTable.otherData.length > 0">
        <tr v-for="(item, index) in dataPeriodicallyCareTable.otherData" :key="'otherdata' + index">
          <td colspan="99">
            {{item.text}}
          </td>
        </tr>
        </tbody>
        <tbody v-else>
          <tr><td colspan="12" class="text-center" style="color:red">Không có kết quả phù hợp</td></tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import {
  TYPE_CURRICULUM_OBJ,
  SCHOOL_LEVEL,
} from '@/helpers/constant';
import watchCheckallBox from '@/mixins/watchCheckallBox';
import { mapGetters, mapState } from 'vuex';
import TokenService from '@/helpers/token';

import copyMobile from '../../mixins/StudentCareMixins';
import StudentCareServices from '../../../../services/StudentCareServices';

export default {
  name: 'CourseExtensionTable',
  components: {},
  mixins: [watchCheckallBox, copyMobile],
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
    studentForm: {
      type: Object,
      default: () => {
      },
    },
    teachers: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      TYPE_CURRICULUM_OBJ,
      totalSelected: 0,
      isOpenQuickView: false,
      selectedContactId: 0,
      selectedRoutineStudentId: 0,
      selectedCustomerId: 0,
      selectedStudent: {},
      homeroomTeacherName: '',
    };
  },
  computed: {
    ...mapState('student_care', ['dataPeriodicallyCareTable', 'courseExtensionShowField', 'typeHeaderStatusModule', 'countStatusModuleList', 'totalContactModule']),
    ...mapState('contact_status', ['listStatus']),
    ...mapGetters('contact_status', ['mapCallStatus']),
    ...mapGetters(['getDevice']),
    tableHeight() {
      const SUB_HEIGHT = 220;
      return this.getDevice.height - SUB_HEIGHT;
    },
  },
  methods: {
    handleSortUpdatedAt() {
      Bus.$emit('sort-updated-at');
    },
    showQuickView(item) {
      const routeData = this.$router.resolve({
        name: 'StudentDetailTutor',
        params: { id: item.id },
        query: { typeCurriculum: this.$route.query.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel, taskType: 1 },
      });
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
        if (this.checkAuthorization('tutor-student-detail-secondary_read')) {
          window.open(routeData.href, '_blank');
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      } else if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        const showModal = this.checkAuthorization('tutor-student-detail_read');
        if (showModal) {
          window.open(routeData.href, '_blank');
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      } else if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        const showModal = this.checkAuthorization('student-detail-ieltsy_read');
        if (showModal) {
          this.$emit('show-modal-quick-view', item);
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    async clickExecuteCall(dataContact, phone) {
      const phoneRes = await StudentCareServices.getMobile(dataContact.id);
      const phoneCall = phoneRes && phoneRes.success ? phoneRes.data : null;
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phoneCall,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phoneCall,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
        };
        Bus.$emit('voice-call-show-popup', data);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    async clickExecuteCallphoneRelated(dataContact, phone) {
      const phoneRes = await StudentCareServices.getMobile(dataContact.id);
      const phoneCall = phoneRes && phoneRes.success ? phoneRes.data : null;
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phoneCall,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
        };
        Bus.$emit('voice-call-show-popup', data);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex}` : '';
    },
    onChangeCheckboxAll() {
      if (this.filterForm.checkboxAll) {
        this.totalSelected = this.dataPeriodicallyCareTable.data.length;
      } else {
        this.totalSelected = 0;
      }
      this.dataPeriodicallyCareTable.data.forEach((contact) => {
        const contactTemp = contact;
        contactTemp.checkbox = this.filterForm.checkboxAll && !contact.mainId;
      });
    },
    changeItemSelect(isChecked) {
      if (isChecked) {
        this.totalSelected += 1;
      } else {
        this.totalSelected -= 1;
      }
    },
    closeModalQuickView() {
      this.isOpenQuickView = false;
      this.selectedContactId = 0;
    },
    createTask(item) {
      Bus.$emit('openModalTriggerTask', null, item);
    },
  },
};

</script>

<style scoped>
.table-contact tbody tr {
  height: 50px;
}

.table-contact table {
  border: 1px solid #d2d2d2;
}

.table-contact table .bg-hover:hover .child-table td:last-child {
  background: #e0e0e0;
}

.table-contact table .bg-hover:hover tr .scroll-layout-left {
  background: #e0e0e0;
}

.table-contact thead tr {
  height: 35px;
}

.table-contact thead th {
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
}

.table-contact thead th:last-child {
  border-right: 0;
}

.table-contact thead .th-id {
  min-width: 50px;
}

.table-contact .child-table td:last-child {
  border-right: 1px solid #d2d2d2;
}

.table-contact .child-table:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}

.table-contact td {
  position: relative;
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
  color: #000000;
}

.table-contact td:last-child {
  border-right: 0;
}

.table-contact .table-layout-checkbox {
  position: relative;
}

.table-contact .table-layout-checkbox .v-input--selection-controls__input {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.v-data-table td {
  font-weight: 300;
  padding: 12px 8px;
}

/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  text-align: left;
  font-size: 15px !important
}

tbody .action-cell {
  text-align: center;
}

tbody .tr-numerical-order {
  text-align: center;
}

thead th {
  height: 30px;
}

/deep/ .table-layout-checkbox .v-input--selection-controls__input {
  z-index: 1;
}

/deep/ .th_childFullName {
  min-width: 170px;
}

/deep/ .th_parentFullName {
  min-width: 170px;
}

/deep/ .th_description {
  min-width: 200px;
}

/deep/ .th_user {
  min-width: 170px;
}

/deep/ .th_email {
  min-width: 150px;
}

/deep/ .th_detailAddress {
  min-width: 250px;
}

/deep/ .th_productDescription {
  max-width: 250px;
}

/deep/ .th_numberOfCall {
  max-width: 20px;
}

/deep/ .th_appointment {
  min-width: 200px;
}

.appointment-time-wrapper {
  padding: 2px 0px;
  border: thin solid #A9A9A9;
  border-radius: 5px;
  cursor: pointer;
  min-width: 140px;
}

.custom-span-title-study-result {
  color: black;
  font-size: 13px !important;
  text-transform: none !important;
}

/deep/ .btn-show-modal-study-result span.v-btn__content {
  justify-content: normal !important;
}

.icon-comment {
  margin-left: 5px;
}

.btn-show-modal-count-interaction {
  position: absolute;
  top: 20%;
  right: 0%;
}

/deep/ .v-text-field--is-booted .v-input__control .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
}

/deep/ .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d9dbe9 !important;
}

/deep/ .v-text-field--is-booted {
  padding-top: unset !important;
  margin-top: unset !important;
}

/deep/
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
> .v-input__control
> .v-input__slot
fieldset {
  border: 1px !important;
}

.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}

.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}

.ch-tag-trial {
  color: #F2994A;
  border: 1px solid #F2994A;
}

.v-tag-trial {
  color: #4F4F4F;
  border: 1px solid #4F4F4F;
}
.sroll-left {
  /* position: fixed; */
  position: sticky;
  background: #fff;
  border-left: 1px solid #d2d2d2!important;
}
td.sroll-left {
  z-index: 1;
}
 /deep/ .v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th.sroll-left {
    border-bottom: 0px !important;
    position: sticky;
    top: 0;
    z-index: 3;
}

@media screen and (max-width: 767px) {
  /deep/ .scroll-layout-left {
    position: unset !important;
  }

  /deep/ .th_mobile, .th_birthday, .th_childFullName, .th_checkbox, .th-id {
    position: sticky !important;
    left: unset !important;
  }
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: unset;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background: #94bdf6 !important;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 8px !important;
}

.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}

.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}

.ch-tag-trial {
  color: #f2994a;
  border: 1px solid #f2994a;
}

.v-tag-trial {
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
}

.list-status-history {
  margin-right: 5px;
  width: 39px;
  height: 25px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  padding-top: 5px;
}

.course-extension-checkbox {
  width: 18px;
  height: 18px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 2px;
  cursor: pointer;
  accent-color: #E91E63;
}
</style>
